export class Usuario {

    apellidoUsuario: string;
    codigoPerfil: string;
    nombreEmpresa: string;
    nombreUsuario: string;
    perfilUsuario: string;
    rucEmpresa: string;
    //datos de accesso
    usuarioCuenta: string;
    claveUsuario: string;

    fillFromJSON(json: string) {
        var jsonObj = JSON.parse(json);
        for (var propName in jsonObj) {
            this[propName] = jsonObj[propName]
        }
    }
}



// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/domain/usuario.ts